import { render, staticRenderFns } from "./CauchyInequalityViz.vue?vue&type=template&id=eddb4dc0&scoped=true"
import script from "./CauchyInequalityViz.vue?vue&type=script&lang=js"
export * from "./CauchyInequalityViz.vue?vue&type=script&lang=js"
import style0 from "./CauchyInequalityViz.vue?vue&type=style&index=0&id=eddb4dc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddb4dc0",
  null
  
)

export default component.exports